import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api-service';
import { HttpClient } from '@angular/common/http';
import { User } from 'app/models/User';
import { UserInfo } from '../models/UserInfo';

/**
 * Filters accepted by the getActivityLogs endpoint (ActivityLogServlet).
 * fromDate/toDate are yyyy-MM-dd and the server rejects one without the other.
 */
export interface ActivityLogFilters {
  fromDate?: string;
  toDate?: string;
  user?: string;
  operation?: string;
  mrtType?: string;
}

@Injectable()
export class QuotaService extends BaseApiService {
  private userInfo: UserInfo;

  constructor(private http: HttpClient, private _userService: User) {
    super();
    this.userInfo = this._userService.getIdentity();
  }

  /**
   * Quota per entity. If one entity's quota lookup fails, the response is
   * still 200 with the entities that worked, and the failed ones are listed
   * in `unavailable` by the same Entity name (Domain, App, CTV). It is a 500
   * only when every entity fails, so this now rejects on HTTP error rather
   * than leaving callers waiting forever.
   */
  getQuotaUsage() {
    return new Promise((resolve, reject) => {
      const urlString = `${this.getRatingsBaseUrl()}/accountBalance`;
      this.http.get(urlString).subscribe(
        res => {
          resolve(res);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getActivityLogs(start = 0, limit = 15, filters: ActivityLogFilters = {}) {
    return new Promise(resolve => {
      let urlString = `${this.getRatingsBaseUrl(
        '2020'
      )}/getActivityLogs?start=${start}&limit=${limit}`;
      if (this.userInfo && this.userInfo.clientId) {
        urlString += `&clientId=${this.userInfo.clientId}`;
      }

      // fromDate and toDate must be sent together or the server returns 400.
      if (filters.fromDate && filters.toDate) {
        urlString += `&fromDate=${encodeURIComponent(filters.fromDate)}`;
        urlString += `&toDate=${encodeURIComponent(filters.toDate)}`;
      }
      if (filters.user) {
        urlString += `&user=${encodeURIComponent(filters.user)}`;
      }
      if (filters.operation) {
        urlString += `&operation=${encodeURIComponent(filters.operation)}`;
      }
      if (filters.mrtType) {
        urlString += `&mrtType=${encodeURIComponent(filters.mrtType)}`;
      }

      this.http.get(urlString).subscribe(res => {
        resolve(res);
      });
    });
  }
}
